import { render, staticRenderFns } from "./ListGroup.vue?vue&type=template&id=85de1fac"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"
import style0 from "./ListGroup.vue?vue&type=style&index=0&id=85de1fac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports